export enum TypeCancelEnum {
    excluded = 'excluded',
    canceled = 'canceled',
    revoked = 'revoked',
    suspended = 'suspended',
    fail = 'fail',
}